

import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {KisiKurumTuru} from "@/enum/KisiKurumTuru";
import {KisiEntity} from "@/entity/KisiEntity";
import {KurumEntity} from "@/entity/KurumEntity";
import KisiTipiPicker from "@/components/pickers/KisiTipiPicker.vue";
import KisiForm from "@/components/forms/KisiForm.vue";
import KurumForm from "@/components/forms/KurumForm.vue";

@Component({
  components: {KurumForm, KisiForm, KisiTipiPicker,}
})
export default class platform extends Mixins(ObjectInputMixin) {
  @Prop() searched!: boolean;
  @Prop() hideButton!: any;
  @Prop({ default: () => [] }) existings!: Array<KisiEntity | KurumEntity>
  @Prop() muvekkilMi !: boolean;
  @Prop() isAddressEmpty !: boolean;

  searchItems: Array<KisiEntity | KurumEntity> = [];
  selectedItem: KisiEntity | KurumEntity = new KisiEntity() || new KurumEntity();
  searchLabel: string = "";
  searchText: string = "";
  aramadakiVergiNo: string = ""; // Arama yapılan vergi numarasını saklamak için

  @Watch('value')
  protected onValueChange() {
    this.localValue = this.value;
  }

  get sahisMi(): boolean {
    if (this.localValue.kisi_kurum_turu) {
      return this.localValue.kisi_kurum_turu == KisiKurumTuru.sahis;
    }
    return !!this.localValue.kisi;
  }

  get sirketMi(): boolean {
    if (this.localValue.kisi_kurum_turu) {
      return this.localValue.kisi_kurum_turu == KisiKurumTuru.sirket;
    }
    return !!this.localValue.kurum;
  }

  get isHideButton() {
    return this.hideButton || this.hideButton === "";
  }

  vekiller(){
    this.$emit('vekiller')
  }

  mounted() {
    if (!this.value) {
      this.onKisiKurumTuruChange();
      this.searchItems = [];
      this.addNewItemOption();
    } else {
      this.input();
    }
  }

  @Watch('searchText')
  onSearchTextChange() {
    this.search();
  }

  timeoutId: any = null;
  minSearchLength = 2; // Minimum arama uzunluğu artırıldı

  load() {
    this.$emit("load");
  }

  onKisiKurumTuruChange() {
    delete this.localValue.kisi;
    delete this.localValue.kurum;
    if (this.sahisMi) {
      this.localValue.kisi = new KisiEntity();
      this.searchLabel = "TC Kimlik No veya İsim";
    } else if (this.localValue.kisi_kurum_turu == KisiKurumTuru.sirket) {
      this.localValue.kurum = new KurumEntity();
      this.searchLabel = "Vergi No, Sicil No, Mersis No veya İsim";
    }
    this.input();
  }

  onKisiKurumChange() {
    if (this.sahisMi) {
      if (this.selectedItem.id === 0) {
        this.localValue.kisi = new KisiEntity();
        this.localValue.kisi.id = 0;
        this.clearSearchForm();
      } else {
        this.localValue.kisi = this.selectedItem;
        const action = `/api/v1/kisi/${this.localValue.kisi.id}`;
        this.$http.get(action)
            .then((response) => {
              this.localValue.kisi = response.data.kisi;
              this.localValue.kisi.borcluVekilleri = response.data.borcluVekilleri || [];
              this.$emit('selected', response.data);
              this.clearSearchForm();
              this.input();
            })
            .catch(error => {
              console.error("Kişi bilgileri alınırken hata oluştu:", error);
            });
      }

    } else if (this.sirketMi) {
      if (this.selectedItem.id === 0) {
        this.localValue.kurum = new KurumEntity();
        this.localValue.kurum.id = 0;
        this.clearSearchForm();
      } else if (typeof this.selectedItem.id === 'undefined') {
        this.localValue.kurum = this.selectedItem;
        // Aynı vekalet no ile devam et seçildi
        this.ayniVekaletNoIleDevam();
      } else {
        this.localValue.kurum = this.selectedItem;
        const action = `/api/v1/kurum/${this.localValue.kurum.id}`;
        this.$http.get(action)
            .then((response) => {
              this.localValue.kurum = response.data;
              this.$emit('selected', response.data);
              this.clearSearchForm();
              this.input();
            })
            .catch(error => {
              console.error("Kurum bilgileri alınırken hata oluştu:", error);
            });
      }
    }
  }

  // Yeni method: Aynı vekalet no ile devam et
  ayniVekaletNoIleDevam() {
    // Yeni bir kurum oluştur
    this.localValue.kurum = new KurumEntity();
    this.localValue.kurum.id = 0;
    this.localValue.kurum.sirket_adi = "";
    this.localValue.kurum.ayniVergiNoIleYeniKurum = true; // Yeni kurum flag'i

    // Arama yapılan vergi numarasını yeni kuruma ata
    if (this.aramadakiVergiNo) {
      this.localValue.kurum.vergi_no = this.aramadakiVergiNo;
    }

    // Formu göster
    this.$emit('change');
    this.input();
  }

  clearSearchForm() {
    this.$emit('change');
    this.selectedItem = new KisiEntity();
    this.searchText = "";
  }

  async search() {
    clearTimeout(this.timeoutId);

    // Standart "yeni kayıt" seçeneğini tanımla
    const yeniKisiOption = {
      ...new KisiEntity(),
      ...new KurumEntity(),
      id: 0,
      ad: "Yeni Kişi",
      soyad: "",
      sirket_adi: "Yeni Kurum",
    };

    // Bizim özel "aynı vergi no ile" seçeneğimizi tanımla
    const ayniVekaletOption = {
      ...new KurumEntity(),
      id: undefined,
      sirket_adi: "Aynı vergi numarası ile yeni kurum ekle", // Template'de görünen metin bu olmayacak, bu sadece bir placeholder
    };

    // Eğer arama metni yoksa veya çok kısaysa, varsayılan listeyi göster ve çık
    if (!this.searchText || this.searchText.length < this.minSearchLength) {
      this.searchItems = [yeniKisiOption];
      if (this.sirketMi) {
        this.searchItems.push(ayniVekaletOption);
      }
      return;
    }

    // Arama metni varsa, API isteğini hazırla
    this.timeoutId = setTimeout(() => {
      // Arama yapılan vergi numarasını sakla
      if (this.sirketMi && /^\d{10,11}$/.test(this.searchText)) {
        this.aramadakiVergiNo = this.searchText;
      } else {
        this.aramadakiVergiNo = "";
      }

      let action = "";
      if (this.sahisMi) {
        action = '/api/v1/kisi/filter?keyword=' + encodeURIComponent(this.searchText.toLowerCase());
      } else if (this.sirketMi) {
        action = '/api/v1/kurum/filter?keyword=' + encodeURIComponent(this.searchText.toLowerCase());
      }

      if (action !== "") {
        this.$http.get(action).then((response) => {
          let apiResults = [];
          if (response && response.data) {
            if (Array.isArray(response.data)) apiResults = response.data;
            else if (response.data.items && Array.isArray(response.data.items)) apiResults = response.data.items;
            else if (response.data.data && Array.isArray(response.data.data)) apiResults = response.data.data;
            else if (typeof response.data === 'object' && Object.keys(response.data).length > 0) apiResults = [response.data];
          }

          const filteredResults = this.filterExistings(apiResults);
          const matchingResults = this.filterBySearchText(filteredResults);

          // Arama sonuçlarını ve "Yeni" seçeneğini listeye ekle
          this.searchItems = [yeniKisiOption, ...matchingResults];

          // ✅ KRİTİK DEĞİŞİKLİK: Eğer tür "Kurum" ise, sonuç olsun ya da olmasın, özel seçeneği her zaman ekle.
          if (this.sirketMi) {
            this.searchItems.push(ayniVekaletOption);
          }

        }).catch((error) => {
          console.error("API Hatası:", error);
          // Hata durumunda bile listeyi doğru şekilde ayarla
          this.searchItems = [yeniKisiOption];
          if (this.sirketMi) {
            this.searchItems.push(ayniVekaletOption);
          }
        });
      }
    }, 300);
  }
  filterExistings(items: Array<KisiEntity | KurumEntity>) {
    if (!this.existings || !Array.isArray(this.existings)) {
      return items;
    }
    return items.filter((item: KisiEntity | KurumEntity) => {
      return this.existings
          .filter((ex: KisiEntity | KurumEntity) => ex && ex.id === item.id)
          .length === 0;
    });
  }

  filterBySearchText(items: Array<KisiEntity | KurumEntity>) {
    if (!this.searchText) {
      return items;
    }
    const searchLower = this.searchText.toLocaleLowerCase('tr-TR'); // Türkçe karakter desteği eklendi
    return items.filter((item: any) => {
      try {
        if (this.sahisMi) {
          const ad = item.ad ? item.ad.toString().toLocaleLowerCase('tr-TR') : '';
          const soyad = item.soyad ? item.soyad.toString().toLocaleLowerCase('tr-TR') : '';
          const tcNo = item.tc_kimlik_no ? item.tc_kimlik_no.toString() : '';
          return ad.includes(searchLower) ||
              soyad.includes(searchLower) ||
              tcNo.includes(searchLower);
        } else if (this.sirketMi) {
          const sirketAdi = item.sirket_adi ? item.sirket_adi.toString().toLocaleLowerCase('tr-TR') : '';
          const vergiNo = item.vergi_no ? item.vergi_no.toString() : '';
          const mersisNo = item.mersis_no ? item.mersis_no.toString() : '';
          return sirketAdi.includes(searchLower) ||
              vergiNo.includes(searchLower) ||
              mersisNo.includes(searchLower);
        }
        return false;
      } catch (error) {
        console.error("Filtreleme hatası:", error);
        return false;
      }
    });
  }

  addNewItemOption() {
    const newItem = {
      ...new KisiEntity(),
      ...new KurumEntity(),
      id: 0,
      ad: "Yeni Kişi",
      soyad: "",
      sirket_adi: "Yeni Kurum"
    };
    this.searchItems = [newItem, ...this.searchItems];
  }

  updateSearchText(newSearchText: string) {
    this.searchText = newSearchText;
  }

  forceMenuOpen() {
    if (this.searchItems.length <= 1) {
      const yeniKisiOption = {
        ...new KisiEntity(),
        ...new KurumEntity(),
        id: 0,
        ad: "Yeni Kişi",
        soyad: "",
        sirket_adi: "Yeni Kurum"
      };

      this.searchItems = [yeniKisiOption];
    }
  }
};
